<template>
    <div class="row p-3">
        <input-radio class="col-12" label="Alcançado?" :options="options.simnao" v-model="form.alcancado" ref="alcancado" required/>
        <input-textarea class="col-12" label="Justificativa" v-model="form.justificativa" ref="justificativa" :required="form.alcancado == 'N'" :readonly="form.alcancado == 'S'" :max-length="1000" placeholder="Máximo 1000 caracteres"/>
        <input-textarea class="col-12" label="Especificação técnica" v-model="form.especificacaoTecnica" ref="especificacao" required :max-length="1000" placeholder="Máximo 1000 caracteres"/>
        <div class="col-12">
            <b-button  variant="success" v-if="controlesLiberados && permissao.u" @click="salvar">
                <i class="fa-solid fa-check mr-2"></i>
                Salvar
            </b-button>
        </div>
    </div>
</template>
<script>
import InputRadio from "@/components/inputs/InputRadio.vue";
import InputTextarea from "@/components/inputs/InputTextarea.vue";

import {FormMixin} from "@/common/mixins/FormMixin";

export default {
    name: "ProdutoPrincipal",
    mixins: [FormMixin],
    components: {
        InputRadio,
        InputTextarea,
    },
    props : {
        objeto : {
            type : Object,
            default : () => ({
                alcancado: "N",
                justificativa: "",
                especificacaoTecnica: "",
            })
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        },
    },
    data : () => ({
        options : {
            simnao : [
                { value : "S", text : "Sim" },
                { value : "N", text : "Não" },
            ]
        },
        form : {
            alcancado: "N",
            justificativa: "",
            especificacaoTecnica: "",
        }
    }),
    methods : {
        salvar : function(){
            this.$emit("salvar", this.form);   
        }
    },
    watch : {
        objeto : {
            handler : function(val){
                if(val)
                    this.form = val;
            },
            deep : true,
            immediate : true
        }
    },
    
    computed : {
        controlesLiberados :function(){
            return this.projetoEditavel
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosPdCaracteristicaProjeto');
        },
    }
}
</script>
<style lang="">
    
</style>